import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import Loader from "../components/loader";
import Table from "../containers/_giftCards/table";
import Layout from "../layouts/layout";
import GIFT_CARDS from "../api/services/GIFT_CARDS";
import styles from "../styles/_screens/giftCards.module.scss";
import SideMenu from "../components/sideMenu";
import { GiftSvg } from "../svgs/giftSvg";

const GiftCards = () => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [responseStatus, setResponseStatus] = useState(null);
  const navigate = useNavigate();

  // FETCH GIFT CARDS
  useEffect(() => {
    setResponseStatus(null);
    const fetchData = async () => {
      try {
        const res = await GIFT_CARDS.get_gift_cards(page, size);
        if (page === 1) {
          setData(res.giftCards);
        } else {
          setData((prev) => [...prev, ...res.giftCards]);
        }
        setTotalPages(res.totalPages);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [responseStatus, page, size]);

  const sideMenuList = [
    {
      id: 1,
      svg: <GiftSvg fill="#DE1468" />,
      text: "גיפט קארדס",
      active: true,
    },
    {
      id: 2,
      svg: <GiftSvg fill="#000000" />,
      text: "היסטוריית רכישות",
      active: false,
      onClick: () => navigate(paths.giftCardPurchaseHistory),
    },
    {
      id: 3,
      svg: <GiftSvg fill="#000000" />,
      text: "שימוש בגיפט קארדס",
      active: false,
      onClick: () => navigate(paths.giftCardConsumptionHistory),
    },
  ];

  if (!data) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <div className={styles.main}>
              <Loader />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          {/* SIDE MENU */}
          <SideMenu list={sideMenuList} />
          <div className={styles.main}>
            <Table data={data} setResponseStatus={setResponseStatus} />
            {page < totalPages && (
              <button
                className={styles.button}
                onClick={() => setPage((prev) => prev + 1)}
              >
                load more
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default GiftCards;
